import React from 'react';

export default function LockedSlotIcon() {
  return (
    <img
      alt="Locked"
      src="/img/icons/ico_slot_locked.png"
      height={25}
      width={25}
      style={{
        position: 'absolute',
        top: -4,
        right: -4,
      }}
    />
  );
}